import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from '@app/models/_base/breadcrumb.model';
import { FinalisedShortlistCourse } from '@app/models/research/research.models';
import { Footer } from '@app/services/footer.service';
import { LocalisationService } from '@app/services/localisation.service';
import { ResearchService } from '@app/services/research.service';
import { RouteBreadcrumbs } from '@app/services/routeBreadcrumbs.service';

import { ExportComponent } from '../export/export.component';

@Component({
  selector: 'app-finalise-list',
  templateUrl: './finalise-list.component.html',
  styleUrls: ['./finalise-list.component.scss']
})
export class FinaliseListComponent implements OnInit {
  static route: string = 'finalise';

  locale: any = {};
  courses: FinalisedShortlistCourse[] = [];

  constructor(
    private routeBreadcrumbs: RouteBreadcrumbs,
    private footer: Footer,
    private localisation: LocalisationService,
    private researchService: ResearchService
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('FinaliseListComponent');

    this.routeBreadcrumbs.breadcrumbs.next([new Breadcrumb(this.locale.breadcrumbText, null)]);

    this.footer.update({
      action: ExportComponent.route,
      title: this.locale.footerText
    });

    this.researchService.getFinalisedList().subscribe(result => {
      this.courses = result.courses;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/finalise/list/finalise-list.component.ts